import React, { Component } from "react";
import { Spin, message, Switch } from "antd";
import Header from "./layout/Header";
import PasswordNotesTooltip from "./components/PasswordNotesTooltip";
import Footer from "./layout/Footer";
import Bridge from "./utils/Bridge";
import { RESEARCH_TYPE } from "./utils/consts";
import { translateApiMessage } from "./utils/functions";

import englishJson from "./utils/language/leStudy/english.json";
import spanishJson from "./utils/language/leStudy/spanish.json";

class ForgotPassword extends Component {
  // state list
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      loading: false,
      type1: "password",
      is_otp_sent: false,
      is_otp_verified: false,
      otp: "",

      new_password: "",
      confirm_password: "",
      newp_type: "password",
      confirmp_type: "password",
      selectedToggleLanguage: "English",
    };
  }
  // on change inputs
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  // show hide password
  togglePassword = (param) => {
    if (param == "new") {
      this.setState({
        newp_type: this.state.newp_type == "password" ? "text" : "password",
      });
    } else if (param == "confirm") {
      this.setState({
        confirmp_type:
          this.state.confirmp_type == "password" ? "text" : "password",
      });
    }
  };
  // send otp
  send_otp = () => {
    const formData =
      this.state.selectedToggleLanguage == "English"
        ? englishJson
        : spanishJson;
    if (!this.state.email) {
      message.warning(formData.page.forgotPassword.form.messages.validation.emailRequired);
      return;
    }
    let params = {
      email: this.state.email,
      research_type: RESEARCH_TYPE,
    };
    this.setState({ loading: true });
    Bridge.forgot_password
      .send_otp(params)
      .then((response) => {
        if (response.data.status == "1") {
          const language = this.state.selectedToggleLanguage || "English";
          message.success(translateApiMessage(response.data.message, language));
          this.setState({ loading: false, is_otp_sent: true });
        } else {
          const language = this.state.selectedToggleLanguage || "English";
          message.error(translateApiMessage(response.data.message, language));
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        const formData =
          this.state.selectedToggleLanguage == "English"
            ? englishJson
            : spanishJson;
        message.warning(formData.page.createAccount.messages.validation.pleaseTryAgain);
        this.setState({ loading: false });
      });
  };
  // verify
  verify_otp = () => {
    const formData =
      this.state.selectedToggleLanguage == "English"
        ? englishJson
        : spanishJson;
    if (!this.state.email) {
      message.warning(formData.page.forgotPassword.form.messages.validation.emailRequired);
      return;
    }
    if (!this.state.otp) {
      message.warning(formData.page.forgotPassword.form.messages.validation.pleaseEnterOtp);
      return;
    }
    if (this.state.otp.length != 6) {
      message.warning(formData.page.forgotPassword.form.messages.validation.invalidOtp);
      return;
    }
    let params = {
      email: this.state.email,
      otp: this.state.otp,
      research_type: RESEARCH_TYPE,
    };
    this.setState({ loading: true });
    Bridge.forgot_password
      .verify_otp(params)
      .then((response) => {
        if (response.data.status == "1") {
          const language = this.state.selectedToggleLanguage || "English";
          message.success(translateApiMessage(response.data.message, language));
          this.setState({ loading: false, is_otp_verified: true });
        } else {
          const language = this.state.selectedToggleLanguage || "English";
          message.error(translateApiMessage(response.data.message, language));
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        const formData =
          this.state.selectedToggleLanguage == "English"
            ? englishJson
            : spanishJson;
        message.warning(formData.page.forgotPassword.form.messages.validation.pleaseTryAgain);
        this.setState({ loading: false });
      });
  };
  reset_password = () => {
    const formData =
      this.state.selectedToggleLanguage == "English"
        ? englishJson
        : spanishJson;
    if (!this.state.email) {
      message.warning(formData.page.createAccount.messages.validation.invalidRequest);
      return;
    }
    let new_password = this.state.new_password;
    let confirm_password = this.state.confirm_password;
    if (!new_password) {
      message.warning(formData.page.forgotPassword.form.messages.validation.newPasswordRequired);
      return;
    }
    let lowerCaseLetters = /[a-z]/g;
    let upperCaseLetters = /[A-Z]/g;
    let numbers = /[0-9]/g;
    let specialCharacters = /[!@#\$%\^&\*]/g;
    if (!new_password.match(lowerCaseLetters)) {
      message.warning(formData.page.changePassword.messages.validation.newPasswordLowercase);
      return;
    }
    if (!new_password.match(upperCaseLetters)) {
      message.warning(formData.page.changePassword.messages.validation.newPasswordUppercase);
      return;
    }
    if (!new_password.match(numbers)) {
      message.warning(formData.page.changePassword.messages.validation.newPasswordNumber);
      return;
    }
    if (!new_password.match(specialCharacters)) {
      message.warning(formData.page.changePassword.messages.validation.newPasswordSpecialChar);
      return;
    }
    if (new_password.length < 8 || new_password.length > 15) {
      message.warning(formData.page.changePassword.messages.validation.newPasswordLength);
      return;
    }
    if (!confirm_password) {
      message.warning(formData.page.forgotPassword.form.messages.validation.confirmPasswordRequired);
      return;
    }
    if (new_password !== confirm_password) {
      message.warning(formData.page.createAccount.messages.validation.passwordMismatch);
      return;
    }
    let params = {
      email: this.state.email,
      new_password: new_password,
      confirm_password: confirm_password,
      research_type: RESEARCH_TYPE,
    };
    this.setState({ loading: true });
    Bridge.forgot_password
      .reset_password(params)
      .then((response) => {
        if (response.data.status == "1") {
          const language = this.state.selectedToggleLanguage || "English";
          message.success(translateApiMessage(response.data.message, language));
          this.setState({ loading: false }, () => {
            setTimeout(() => {
              window.location.assign("/");
            }, 3000);
          });
        } else {
          const language = this.state.selectedToggleLanguage || "English";
          message.error(translateApiMessage(response.data.message, language));
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        const formData =
          this.state.selectedToggleLanguage == "English"
            ? englishJson
            : spanishJson;
        message.warning(formData.page.createAccount.messages.validation.pleaseTryAgain);
        this.setState({ loading: false });
      });
  };
  handleLanguageChange = (value) => {
    this.setState({
      selectedToggleLanguage: value,
    });
  };
  render() {
    let formData = englishJson;
    if (RESEARCH_TYPE == "LE Study") {
      formData = this.state.selectedToggleLanguage === "English" ? englishJson : spanishJson;
    }
    return (
      <>
        <Header selectedLanguage={this.state.selectedToggleLanguage} />
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="authenitication-form">
                <div className="dark-side d-none d-sm-none d-md-none d-lg-block d-xl-block">
                  <img src={"./assets/images/dark-logo.jpg"} />
                  <p className="inner-text">
                    {formData.page.createAccount.missionStatement}
                  </p>
                </div>
                <div className="right-sides-form">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="d-flex justify-content-between">
                          <h2
                            style={{
                              marginBottom: 0,
                              paddingBottom: 10,
                            }}
                          >
                            {formData.page.forgotPassword.title}
                          </h2>
                          {RESEARCH_TYPE == "LE Study" && (
                            <div className="form-field">
                              <label style={{ width: "fit-content" }}>
                                Language &nbsp;&nbsp;&nbsp;
                                <Switch
                                  checkedChildren={<b>English</b>}
                                  unCheckedChildren={<b>Spanish</b>}
                                  defaultChecked
                                  checked={this.state.selectedToggleLanguage === "English"}
                                  onChange={(e) => this.handleLanguageChange(e ? "English" : "Spanish")}
                                />
                              </label>
                            </div>
                          )}
                        </div>
                        <p style={{ fontSize: 17 }}>
                          {formData.page.forgotPassword.description}
                        </p>
                        <p style={{ fontSize: 17 }}>
                          {formData.page.forgotPassword.note}
                        </p>
                        <div className="mt-4">
                          <Spin spinning={this.state.loading}>
                            {this.state.is_otp_verified == true ? (
                              <div className="form-wrapper">
                                <div className="form-field">
                                  <label>
                                    <box-icon
                                      style={{
                                        marginTop:
                                          window.innerWidth > 600 ? 0 : -3,
                                        marginRight:
                                          window.innerWidth > 600 ? 12 : 9,
                                      }}
                                      name="lock-alt"
                                      type="solid"
                                      color="#9e9e9e"
                                      size={
                                        window.innerWidth > 600
                                          ? "23px"
                                          : "23px"
                                      }
                                    ></box-icon>
                                    {formData.page.forgotPassword.form.fields.newPassword.label}
                                    <PasswordNotesTooltip language={this.state.selectedToggleLanguage} />
                                  </label>
                                  <input
                                    type={this.state.newp_type}
                                    name="password"
                                    value={this.state.new_password}
                                    onChange={(e) =>
                                      this.setState({
                                        new_password: e.target.value,
                                      })
                                    }
                                  />
                                  <div
                                    className="togglePassword"
                                    onClick={() => this.togglePassword("new")}
                                  >
                                    {this.state.newp_type == "password" ? (
                                      <div className="show-password-icon">
                                        <box-icon
                                          name="show"
                                          color="#ffa3a3"
                                        ></box-icon>
                                      </div>
                                    ) : (
                                      <div className="show-password-icon">
                                        <box-icon
                                          name="low-vision"
                                          color="#ffa3a3"
                                        ></box-icon>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="form-field">
                                  <label>
                                    <box-icon
                                      style={{
                                        marginTop:
                                          window.innerWidth > 600 ? 0 : -3,
                                        marginRight:
                                          window.innerWidth > 600 ? 12 : 9,
                                      }}
                                      name="lock-alt"
                                      type="solid"
                                      color="#9e9e9e"
                                      size={
                                        window.innerWidth > 600
                                          ? "23px"
                                          : "23px"
                                      }
                                    ></box-icon>
                                    {formData.page.forgotPassword.form.fields.confirmNewPassword.label}
                                  </label>
                                  <input
                                    type={this.state.confirmp_type}
                                    name="password"
                                    value={this.state.confirm_password}
                                    onChange={(e) =>
                                      this.setState({
                                        confirm_password: e.target.value,
                                      })
                                    }
                                  />
                                  <div
                                    className="togglePassword"
                                    onClick={() =>
                                      this.togglePassword("confirm")
                                    }
                                  >
                                    {this.state.confirmp_type == "password" ? (
                                      <div className="show-password-icon">
                                        <box-icon
                                          name="show"
                                          color="#ffa3a3"
                                        ></box-icon>
                                      </div>
                                    ) : (
                                      <div className="show-password-icon">
                                        <box-icon
                                          name="low-vision"
                                          color="#ffa3a3"
                                        ></box-icon>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <center>
                                  <button
                                    type="button"
                                    className="submit-button full-width"
                                    onClick={() => this.reset_password()}
                                  >
                                    <box-icon
                                      name="log-in"
                                      color="#fff"
                                      size={"20px"}
                                    ></box-icon>
                                    &nbsp; {formData.page.forgotPassword.form.button.changePassword}
                                  </button>
                                </center>
                              </div>
                            ) : (
                              <div className="form-wrapper">
                                <div className="form-field">
                                  <label>
                                    <box-icon
                                      type="solid"
                                      name="envelope"
                                      color="#9e9e9e"
                                      size={
                                        window.innerWidth > 600
                                          ? "23px"
                                          : "23px"
                                      }
                                      style={{
                                        marginTop:
                                          window.innerWidth > 600 ? 0 : -3,
                                        marginRight:
                                          window.innerWidth > 600 ? 12 : 9,
                                      }}
                                    ></box-icon>{" "}
                                    {formData.page.forgotPassword.form.fields.email.label}
                                  </label>
                                  <input
                                    type="text"
                                    name="email"
                                    value={this.state.email}
                                    onChange={this.handleChange}
                                    disabled={
                                      this.state.is_otp_sent == true
                                        ? true
                                        : false
                                    }
                                  />
                                </div>
                                {this.state.is_otp_sent == true && (
                                  <div className="form-field">
                                    <label>
                                      <box-icon
                                        type="solid"
                                        name="envelope"
                                        color="#9e9e9e"
                                        size={
                                          window.innerWidth > 600
                                            ? "23px"
                                            : "23px"
                                        }
                                        style={{
                                          marginTop:
                                            window.innerWidth > 600 ? 0 : -3,
                                          marginRight:
                                            window.innerWidth > 600 ? 12 : 9,
                                        }}
                                      ></box-icon>{" "}
                                      {formData.page.forgotPassword.form.fields.otp.label}
                                    </label>
                                    <input
                                      type="number"
                                      name="otp"
                                      value={this.state.otp}
                                      onChange={(e) =>
                                        this.setState({ otp: e.target.value })
                                      }
                                      maxLength={6}
                                    />
                                  </div>
                                )}
                                <center>
                                  {this.state.is_otp_sent == true ? (
                                    <button
                                      type="button"
                                      className="submit-button full-width"
                                      onClick={() => this.verify_otp()}
                                    >
                                      <box-icon
                                        name="log-in"
                                        color="#fff"
                                        size={"20px"}
                                      ></box-icon>
                                      &nbsp; {formData.page.forgotPassword.form.button.verifyOtp}
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="submit-button full-width"
                                      onClick={() => this.send_otp()}
                                    >
                                      <box-icon
                                        name="log-in"
                                        color="#fff"
                                        size={"20px"}
                                      ></box-icon>
                                      &nbsp; {formData.page.forgotPassword.form.button.resetPassword}
                                    </button>
                                  )}
                                </center>
                                {!this.state.is_otp_verified && (
                                  <span className="extra-link-with-text">
                                    {formData.page.forgotPassword.form.links.backToLogin} &nbsp;
                                    <a href="/">{formData.page.forgotPassword.form.links.signIn}</a>
                                  </span>
                                )}
                              </div>
                            )}
                          </Spin>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer formData={formData} key={this.state.selectedToggleLanguage} />
      </>
    );
  }
}
export default ForgotPassword;
